import { Pipe, PipeTransform } from '@angular/core';
import get from 'lodash/get';

@Pipe({ name: 'lodashGet', standalone: true, pure: false })
export class LodashGetPipe implements PipeTransform {
    transform(object: any, path: string, defaultValue?: any): any {
        return get(object, path, defaultValue);
    }
}
